<template>
	<footer class="site-footer">
		<div class="container site-footer__inner">
			<div class="site-footer__brand">
				<img
					:src="assetUrl('logo-full-light.png')"
					class="site-footer__logo"
					alt="Beetronix"
					width="689"
					height="200"
					loading="lazy"
				>
				<p class="site-footer__tagline">{{ t('footer.tagline') }}</p>
			</div>

			<div class="site-footer__links">
				<p class="site-footer__links-label">{{ t('footer.downloads') }}</p>
				<a
					:href="PROFILE_FILES.en.href"
					:download="PROFILE_FILES.en.name"
					class="site-footer__link"
				><bdi>{{ t('footer.english') }}</bdi> (PDF)</a>
				<a
					:href="PROFILE_FILES.ar.href"
					:download="PROFILE_FILES.ar.name"
					class="site-footer__link"
				><bdi>{{ t('footer.arabic') }}</bdi> (PDF)</a>
			</div>

			<div class="site-footer__meta">
				<!-- bdi keeps the value reading left-to-right, while the link itself still aligns with the page direction -->
				<a
					:href="CONTACT_INFO.websiteUrl"
					class="site-footer__link"
					target="_blank"
					rel="noopener"
				><bdi dir="ltr">{{ CONTACT_INFO.website }}</bdi></a>
				<a
					:href="`mailto:${CONTACT_INFO.email}`"
					class="site-footer__link"
				><bdi dir="ltr">{{ CONTACT_INFO.email }}</bdi></a>
				<a
					:href="`tel:${CONTACT_INFO.phone}`"
					class="site-footer__link"
				><bdi dir="ltr">{{ CONTACT_INFO.phoneDisplay }}</bdi></a>

				<p class="site-footer__copy">
					<bdi dir="ltr">{{ currentYear }} © Beetronix</bdi> — {{ t('footer.rights') }}
				</p>
			</div>
		</div>
	</footer>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { CONTACT_INFO, PROFILE_FILES } from '@/helpers/constants'
import { assetUrl } from '@/helpers/functions'

defineOptions({ name: 'SiteFooter' })

const { t } = useI18n()

const currentYear = new Date().getFullYear()
</script>

<style scoped lang="scss">
.site-footer {
	padding: clamp(44px, 6vw, 68px) 0 34px;
	background: $color-ink;
	color: #9c9c9c;
}

.site-footer__inner {
	display: grid;
	grid-template-columns: 1.2fr 0.8fr 0.9fr;
	gap: clamp(26px, 4vw, 48px);
	align-items: start;

	@include below($bp-desktop) {
		grid-template-columns: 1fr 1fr;
	}

	@include below($bp-tablet) {
		grid-template-columns: 1fr;
		gap: 30px;
	}
}

.site-footer__logo {
	width: 210px;
	height: auto;
	opacity: 0.95;
}

.site-footer__tagline {
	margin-top: 14px;
	font-size: 0.92rem;
	font-weight: 500;
	letter-spacing: 0.06em;
	color: $color-gold;

	@include arabic {
		letter-spacing: 0;
	}
}

.site-footer__links {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.site-footer__links-label {
	font-size: 0.76rem;
	font-weight: 700;
	letter-spacing: 0.18em;
	text-transform: uppercase;
	color: #f0f0f0;

	@include arabic {
		letter-spacing: 0.04em;
	}
}

.site-footer__link {
	font-size: 0.92rem;
	transition: color 0.2s;

	&:hover {
		color: $color-gold;
	}
}

.site-footer__meta {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.site-footer__copy {
	margin-top: 12px;
	font-size: 0.82rem;
	color: #6d6d6d;
}
</style>
